import React from "react";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface InterruptButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onInterrupt: () => void;
}

const InterruptButton: React.FC<InterruptButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onInterrupt,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="interrupt-button"
      testId="interrupt"
      variant="outlined"
      startIcon={<NotInterestedIcon />}
      onClick={onInterrupt}
    />
  );
};
export default InterruptButton;
